export default "__VITE_ASSET__pq6OiWJ2__"